// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.separator_separator__yNFk\\+ {
  width: 96%;
  height: 0.5px;
  margin-top: 15px;
  margin-bottom: 21px;
  margin-left: 2%;
  border: 0.5px solid var(--hsrcDarkBlue);
  transform: rotate(180deg); }

.separator_full__separator__DaKDm {
  width: 100%;
  height: 0.5px;
  margin-top: 15px;
  margin-bottom: 21px;
  margin-left: 0%;
  border: 0.5px solid var(--hsrcDarkBlue);
  transform: rotate(180deg); }

`, "",{"version":3,"sources":["webpack://./src/components/Separator/separator.module.css"],"names":[],"mappings":";;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,yBAAyB,EAAE;;AAE7B;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,yBAAyB,EAAE","sourcesContent":["\r\n\r\n.separator {\r\n  width: 96%;\r\n  height: 0.5px;\r\n  margin-top: 15px;\r\n  margin-bottom: 21px;\r\n  margin-left: 2%;\r\n  border: 0.5px solid var(--hsrcDarkBlue);\r\n  transform: rotate(180deg); }\r\n\r\n.full__separator {\r\n  width: 100%;\r\n  height: 0.5px;\r\n  margin-top: 15px;\r\n  margin-bottom: 21px;\r\n  margin-left: 0%;\r\n  border: 0.5px solid var(--hsrcDarkBlue);\r\n  transform: rotate(180deg); }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separator": `separator_separator__yNFk+`,
	"full__separator": `separator_full__separator__DaKDm`
};
export default ___CSS_LOADER_EXPORT___;
